import Route from '@ember/routing/route'
import { isEmpty } from 'lodash'
import type FastPhonicsProgressReviewRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/review/route'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

export default class FastPhonicsProgressReviewStudentsRoute extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
    pageNumber: {
      replace: true,
    },
    perPage: {
      replace: true,
    },
  }

  model() {
    const data = this.modelFor(
      'reporting.ui-scope.fast-phonics.progress.review',
    ) as ModelFor<FastPhonicsProgressReviewRoute>
    const studentsData = data?.stats.peaksProgress?.students
    if (!studentsData) return { students: [] }

    // Fetch the students needed for students table
    const { scopedData } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    // Add in the first/last names and classes for each student into the data
    const students = studentsData
      .map((studentData) => {
        const studentRecord = scopedData.students.find((student) => student.id === String(studentData.student_id))
        if (!studentRecord) return null

        const schoolClasses = studentRecord.schoolClassesFor(SubscriptionType.Reading)
        const schoolClassNames = schoolClasses?.map((schoolClass) => schoolClass.name).join(', ')

        return {
          ...studentData,
          firstName: studentRecord.firstName,
          lastName: studentRecord.lastName,
          externalId: studentRecord.externalId,
          schoolClassNames,
        }
      })
      .filter((data) => !isEmpty(data))

    return { students }
  }
}
